// extracted by mini-css-extract-plugin
module.exports = {"link-tags-container":"subcategories-section_link-tags-container__wQpu8","link-tag":"subcategories-section_link-tag__V68LB"};